var map = {
	"./09erp-cb.svg": 9625,
	"./10仓库、仓储-线性.svg": 99261,
	"./12.svg": 46282,
	"./2-4结算.svg": 19782,
	"./API对接、ERP对接-copy.svg": 95477,
	"./ERP-02.svg": 64257,
	"./ERP-首页多功能.svg": 62134,
	"./ERP.svg": 26642,
	"./ERP_xq长协.svg": 23754,
	"./ERP_供应商.svg": 8986,
	"./ERP_单位-copy.svg": 11711,
	"./ERP_启动任务.svg": 76508,
	"./ERP_基本信息.svg": 30491,
	"./ERP_提货信息.svg": 13326,
	"./ERP_未打印.svg": 28688,
	"./ERP_查看.svg": 3953,
	"./ERP_申请人.svg": 81871,
	"./ERP_货款总金额 -copy.svg": 22761,
	"./ERP_货款总金额 .svg": 44397,
	"./ERP_车船号.svg": 80885,
	"./ERP_过磅.svg": 37841,
	"./ERP_首页.svg": 93778,
	"./ERP数据维护.svg": 70892,
	"./ERP未点击.svg": 75012,
	"./ERP系统菜单.svg": 47961,
	"./ERP运营端-额度管理.svg": 10187,
	"./EnterpriseMembers.svg": 73787,
	"./UserPlus.svg": 25126,
	"./bank enterprise-fill.svg": 52292,
	"./bank enterprise-line.svg": 37857,
	"./bxs-layer-plus.svg": 72473,
	"./enterprise (1).svg": 94692,
	"./enterprise.svg": 858,
	"./erp-127.svg": 53921,
	"./erp-28.svg": 83265,
	"./erp-advertisement-banner.svg": 6893,
	"./erp-customer.svg": 31367,
	"./erp-material.svg": 51948,
	"./erp-voucher.svg": 41111,
	"./erp-商品管理.svg": 54273,
	"./erp-基础定义@1x.svg": 32113,
	"./erp-客户管理.svg": 51087,
	"./erp-采购价.svg": 55594,
	"./erp-销售入出库查询.svg": 68322,
	"./erp_9_4.svg": 71015,
	"./erp_fund.svg": 79412,
	"./erp库存.svg": 80031,
	"./erp财务.svg": 94485,
	"./icon-业务特别价格审核申请表.svg": 5826,
	"./interpret.svg": 47482,
	"./layer-property.svg": 49136,
	"./list_销售订单.svg": 17079,
	"./materialGroup.svg": 61381,
	"./organization-structure.svg": 29974,
	"./painter-palette.svg": 88766,
	"./vab.svg": 17902,
	"./vuejs-fill.svg": 96174,
	"./wxb账户.svg": 61065,
	"./下载.svg": 39579,
	"./仓位集.svg": 57863,
	"./企业信息.svg": 38330,
	"./供应商.svg": 86144,
	"./公司管理.svg": 70010,
	"./历史价格.svg": 17314,
	"./合同管理.svg": 55874,
	"./基础设置.svg": 33105,
	"./客户价格.svg": 275,
	"./客户管理.svg": 66327,
	"./库管中心.svg": 63459,
	"./开创云ERP.svg": 71712,
	"./当前价格.svg": 17118,
	"./抵扣券.svg": 45925,
	"./改价.svg": 4767,
	"./教师评价.svg": 31555,
	"./日志.svg": 23523,
	"./活动.svg": 16534,
	"./用户管理.svg": 80225,
	"./系统.svg": 94665,
	"./结算报表.svg": 7282,
	"./统计.svg": 86131,
	"./缴费.svg": 21462,
	"./职务管理.svg": 29503,
	"./行政.svg": 19104,
	"./行政车辆进出记录备份.svg": 99190,
	"./角色管理.svg": 49302,
	"./记录.svg": 12902,
	"./调价.svg": 21737,
	"./财务管理.svg": 48749,
	"./货车_o.svg": 96326,
	"./过磅统计.svg": 39359,
	"./运输单_画板 1.svg": 18079,
	"./运输单位信息.svg": 23154,
	"./采购管理.svg": 39930,
	"./销售.svg": 73485,
	"./销售计划.svg": 25912,
	"./黑名单.svg": 88429
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12781;